import { EProductFieldType } from 'api/types/product';
import { EPriceType } from 'components/NewProductStepper/ProductBaseForm/constants';
import { isValidIntlPhoneNumber } from 'components/Form/InputPhoneMask/utils';
import dayjs from 'dayjs';
import _ from 'lodash';
import * as Yup from 'yup';

export const productStoreValidationSchema = Yup.object().shape({
  date: Yup.string()
    .test('validate-date', `This date is not valid`, function (value) {
      if (!this.parent.preorderBy || this.parent.preorderBy < 0) {
        return true;
      }
      const isValid = dayjs(value).diff(dayjs().add(this.parent.preorderBy, 'day'), 'day') >= 0;
      return isValid;
    })
    // This is used to check if the delivery date is required when the delivery date is shown
    .test('required-date', `This field is required`, function (value) {
      if (this.parent._productShowDeliveryDate && !value) {
        return false;
      }
      return true;
    }),
  guestPrice: Yup.string().test(
    'validate-guest-price',
    'Your payment amount must be greater than $0.50',
    (value, { parent }) => {
      if (
        parent.priceType === EPriceType.VARIABLE ||
        (_.isNumber(parent.selectedProductPriceId) && parent._productPriceIsVariablePrice)
      ) {
        return parseFloat(value) >= 0.5 || parseFloat(value) === 0.0;
      }

      return true;
    },
  ),
  selectedProductPriceId: Yup.number().test(
    'validate-selected-product-price',
    'Please select an option',
    (value, { parent }) => {
      if (parent.priceType === EPriceType.MULTIPLE) {
        return value !== undefined && value !== null;
      }
      return true;
    },
  ),
  // Then the form has extra fields we should check that the value is not empty
  extraFields: Yup.array().of(
    Yup.object().shape({
      value: Yup.string()
        .required('This field is required')
        // The picker can only emit a valid date, but the phone input happily emits a partial
        // number, and the backend rejects anything that isn't E.164
        .test('validate-phone', 'Please enter a valid phone number', function (value) {
          if (this.parent.fieldType !== EProductFieldType.PHONE) {
            return true;
          }
          return isValidIntlPhoneNumber(value);
        }),
    }),
  ),
});
